require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-philippines-first-energy-transition-dpl.json") })
        }
      }, "path---en-us-project-philippines-first-energy-transition-dpl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-philippines-first-energy-transition-dpl!./.cache/json/en-us-project-philippines-first-energy-transition-dpl.json
// module id = 552
// module chunks = 231608221292675